export const ImageAttachment = 'image';
export const ImageAttachmentTypeId = 1;
export const FileAttachment = 'file';
export const FileAttachmentTypeId = 2;
